import React from 'react';
import styled from 'styled-components';

const Categories = () => (
  <H1>Under Construction</H1>
);

export default Categories;

const H1 = styled.h1`
  font-size: 40px;
  text-align: center;
`;
